
import { mergeData } from 'vue-functional-data-merge'

import { ThemeMixin } from '../../mixins'

export default ThemeMixin.extend({
  name: 'WeveCardSubtitle',
  functional: true,
  props: {
    tag: {
      type: String,
      default: 'h3',
    },
  },
  render(h, { props, children, data, injections }) {
    return h(
      props.tag,
      mergeData(data, {
        staticClass: 'app-card__subtitle',
        class: {
          'w-theme--light': injections.theme === 'light',
          'w-theme--dark': injections.theme !== 'light',
        },
      }),
      children,
    )
  },
})
